import { render } from "./list_visits.vue?vue&type=template&id=aeb944cc"
import script from "./list_visits.vue?vue&type=script&lang=js"
export * from "./list_visits.vue?vue&type=script&lang=js"

import "./list_visits.vue?vue&type=style&index=0&id=aeb944cc&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__